module.exports = __webpack_public_path__ + "static/media/20.a48ce2cd.jpeg";